import React from 'react';

const YouTubeSVG = ({ color, width, height }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width ? width : '20'}
    height={height ? height : '20'}
    viewBox="0 0 24 24"
  >
    <path
      fill={color ? color : '#ffffff'}
      fillRule="evenodd"
      d="M21.5820806,7.20030249 C21.3520638,6.33421468 20.6743546,5.65211102 19.8138699,5.42062937 C18.2541794,5 12,5 12,5 C12,5 5.74585724,5 4.18613014,5.42062937 C3.32564535,5.65214764 2.64793622,6.33421468 2.41791941,7.20030249 C2,8.770137 2,12.0454504 2,12.0454504 C2,12.0454504 2,15.3207638 2.41791941,16.8905983 C2.64793622,17.7566861 3.32564535,18.4103718 4.18613014,18.6418535 C5.74585724,19.0624828 12,19.0624828 12,19.0624828 C12,19.0624828 18.2541428,19.0624828 19.8138699,18.6418535 C20.6743546,18.4103718 21.3520638,17.7566861 21.5820806,16.8905983 C22,15.3207638 22,12.0454504 22,12.0454504 C22,12.0454504 22,8.770137 21.5820806,7.20030249 Z M9.95453131,15.0191894 L9.95453131,9.07171134 L15.1817832,12.0455236 L9.95453131,15.0191894 Z"
    />
  </svg>
);

export default YouTubeSVG;
